<script lang="ts">
	import { browser } from '$app/environment';
	import { ClientVelatlasLoggerApi } from '$lib/api/velatlas/velatlas.loggerApi.client';
	import { ANALYTICS_EVENT_NAMES } from '$lib/statics';
	import { PersistedState, watch } from 'runed';
	import IconMoon from '~icons/mdi/weather-night';
	import IconSun from '~icons/mdi/white-balance-sunny';

	const THEMES = {
		light: 'autumn',
		dark: 'luxury'
	} as const;

	type Theme = (typeof THEMES)[keyof typeof THEMES];

	// null means we haven't overridden the system preference yet
	const theme = new PersistedState<Theme | null>('site-theme', null);
	const analyticsApi = new ClientVelatlasLoggerApi();

	let isDark = $state<boolean>(false);

	function toggleTheme() {
		theme.current = isDark ? THEMES.light : THEMES.dark;
	}

	$effect(() => {
		if (browser) {
			if (theme.current) {
				isDark = theme.current === THEMES.dark;
				document.documentElement.setAttribute('data-theme', theme.current);
			} else {
				isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
				const activeTheme = isDark ? THEMES.dark : THEMES.light;
				document.documentElement.setAttribute('data-theme', activeTheme);
			}
		}
	});

	watch(
		() => isDark,
		() => {
			analyticsApi.sendAnalytics({
				event: ANALYTICS_EVENT_NAMES.themeToggle,
				payload: { toDark: isDark }
			});
		},
		{
			lazy: true
		}
	);
</script>

<label class="swap h-full w-full swap-rotate">
	<input type="checkbox" checked={isDark} onchange={toggleTheme} aria-label="Toggle dark mode" />
	<IconSun class="swap-off text-xl" />
	<IconMoon class="swap-on text-xl" />
</label>
